import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import Box from "./Box";
import "./Service.css";
import data from "../Data/Data.js";
import { Grid } from "@mui/material";

const Service = () => {
  return (
    <div className="BG-Service" id="service">
      <div className="container" style={{ paddingBottom: "50px" }}>
        <div className="after">
          <h1>My Services</h1>
          <p>
            I design and develop services for customers of all sizes,
            specializing in creating stylish,
            <br /> modern websites, web services and online stores.
          </p>
        </div>

        <Grid container spacing={2}>
          {data.map((dt) => {
            return (
              <Grid item xs={12} md={6} lg={4}>
                <Box data={dt} id={dt.id} />
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};

export default Service;
